<button class="burger-button" (click)="openMenu()">
  <mat-icon>menu</mat-icon>
</button>

<app-itau-modal [logo]="true" [show]="menuOpened" (close)="onCloseMenu($event)">
  <app-search-bar [mobile]="true" (submitted)="onSubmit($event)"></app-search-bar>
  <hr class="section-divider" />
  <app-burger-modal-option *ngFor="let option of menu" [option]="option" (closeModal)="onCloseMenu($event)"></app-burger-modal-option>
</app-itau-modal>
